import styled from 'styled-components';
import { TextStyle } from 'components/text';
import { device } from 'commons';

export const Main = styled.main`
  flex: 1;
  gap: 16px;
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 24px 48px 50px;

  @media (max-width: ${device.tablet}px) {
    padding: 24px 28px 50px;
  }
`;

export const IntroTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${TextStyle} {
    @media (max-width: ${device.tablet}px) {
      padding-bottom: 24px;
    }
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 16px;
  overflow: auto;

  @media (max-width: ${device.tablet}px) {
    padding-top: 8px;
    overflow: unset;
  }
`;

export const NoBatchToCollect = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

export const CarrierColumnsByDate = styled.div`
  display: flex;
  gap: 16px;

  @media (max-width: ${device.tablet}px) {
    flex-direction: column;
  }
`;

export const BatchWrapper = styled.div<{ $isRow?: boolean }>`
  height: 100%;
  display: flex;
  flex-direction: ${({ $isRow }) => ($isRow ? 'row' : 'column')};
  gap: 16px;

  @media (max-width: ${device.tablet}px) {
    width: 100%;
    flex-direction: column;
  }
`;

export const CarriersColumns = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;

  @media (max-width: ${device.tablet}px) {
    width: 100%;
    flex-direction: column;
  }
`;

export const FilterForm = styled.form`
  display: flex;
  align-items: center;
  gap: 18px;
  width: 100%;

  @media (max-width: ${device.desktopSmall}px) {
    flex-direction: column;
  }
`;

export const SelectWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SelectAndButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;

  @media (max-width: ${device.desktopSmall}px) {
    width: 100%;
  }
`;

export const SmallSelectWrapper = styled(SelectWrapper)`
  width: 286px;

  @media (max-width: ${device.desktopSmall}px) {
    width: 100%;
  }
`;

export const HistoryWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 16px;
`;
